import { axiosInstance } from '@src/configs/axios.configs';
import { IResponse } from '@src/interfaces/axios.interfaces';

import {
  ICancelSubscriptionResponse,
  IRenewSubscriptionResponse,
  ISubscriptionsApplyOfferRequest,
  ISubscriptionsApplyOfferResponse,
  ISubscriptionsInitPaymentRequest,
  ISubscriptionsInitPaymentResponse,
  ISubscriptionsMeResponse,
  ISubscriptionsOfferEligibilityRequest,
  ISubscriptionsOfferEligibilityResponse,
  ISubscriptionsOfferPreviewRequest,
  ISubscriptionsOfferPreviewResponse,
  ISubscriptionsPauseEligibilityResponse,
  ISubscriptionsPauseToggleResponse,
  ISubscriptionsPlansRequest,
  ISubscriptionsPlansResponse,
} from '../types/subscriptions.types';

export const subscriptionsService = {
  plans: (
    params: ISubscriptionsPlansRequest,
  ): IResponse<ISubscriptionsPlansResponse> =>
    axiosInstance('/api/users/subscription/plans', {
      params,
      sendLocale: true,
    }),
  initPayment: (
    data: ISubscriptionsInitPaymentRequest,
  ): IResponse<ISubscriptionsInitPaymentResponse> =>
    axiosInstance.post('/api/users/subscription/init-payment', data),
  quote: (
    data: ISubscriptionsInitPaymentRequest,
  ): IResponse<ISubscriptionsInitPaymentResponse> =>
    axiosInstance.post('/api/users/subscription/quote', data),
  me: (): IResponse<ISubscriptionsMeResponse> =>
    axiosInstance('/api/users/subscription/me', { sendLocale: true }),
  offerEligibility: (
    params: ISubscriptionsOfferEligibilityRequest,
  ): IResponse<ISubscriptionsOfferEligibilityResponse> =>
    axiosInstance('/api/users/subscription/offer-eligibility', { params }),
  freePeriodEligibility:
    (): IResponse<ISubscriptionsOfferEligibilityResponse> =>
      axiosInstance('/api/payment/subscriptions/me/free-period-eligibility'),
  cancelSubscription: (): IResponse<ICancelSubscriptionResponse> =>
    axiosInstance('api/users/subscription/cancel', {
      hideDefaultErrorMessage: true,
    }),
  renewSubscription: (): IResponse<IRenewSubscriptionResponse> =>
    axiosInstance('api/users/subscription/renew', {
      hideDefaultErrorMessage: true,
    }),
  pauseEligibility: (): IResponse<ISubscriptionsPauseEligibilityResponse> =>
    axiosInstance('/api/payment/subscriptions/me/pause-eligibility'),
  pause: (): IResponse<ISubscriptionsPauseToggleResponse> =>
    axiosInstance.post('/api/payment/subscriptions/me/pause', null, {
      hideDefaultErrorMessage: true,
    }),
  unpause: (): IResponse<ISubscriptionsPauseToggleResponse> =>
    axiosInstance.post('/api/payment/subscriptions/me/unpause', {
      hideDefaultErrorMessage: true,
    }),
  applyOffer: ({
    id,
    ...body
  }: ISubscriptionsApplyOfferRequest): IResponse<ISubscriptionsApplyOfferResponse> =>
    axiosInstance.post(`/api/payment/subscriptions/${id}/apply-offer`, body, {
      hideDefaultErrorMessage: true,
    }),
  applyFreePeriod: (): IResponse<ISubscriptionsApplyOfferResponse> =>
    axiosInstance.post(`/api/payment/subscriptions/me/grant-free-period`, {
      hideDefaultErrorMessage: true,
    }),
  offerPreview: (
    params: ISubscriptionsOfferPreviewRequest,
  ): IResponse<ISubscriptionsOfferPreviewResponse> =>
    axiosInstance(`/api/payment/subscriptions/me/offer-preview`, { params }),
};
